import * as React from "react";
import {
  BookOpen,
  Calendar,
  Lightbulb,
  MessageSquare,
  Users,
} from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const items = [
  {
    name: "Chat",
    url: "/mentee/chat",
    icon: MessageSquare,
  },
  {
    name: "Schedule",
    url: "/mentee/appointments",
    icon: Calendar,
  },
  {
    name: "Insights",
    url: "/mentee/insights",
    icon: Lightbulb,
  },
  {
    name: "Resources",
    url: "/mentee/resources",
    icon: BookOpen,
  },
  {
    name: "Mentor",
    url: "/mentee/mentor",
    icon: Users,
  },
];

export function AppSidebar({
  className = "",
  ...props
}: React.ComponentProps<"nav">) {
  const location = useLocation();

  return (
    <nav
      className={`sticky left-0 top-0 z-40 flex h-screen w-20 flex-col items-center border-r bg-[#fafbfc] pt-24 ${className}`}
      {...props}
    >
      <div className="flex w-full flex-col items-center">
        {items.map((item) => {
          const active = location.pathname.startsWith(item.url);
          return (
            <Link
              key={item.name}
              to={item.url}
              className={`mb-4 flex flex-col items-center justify-center rounded-xl p-2 transition-all
                ${
                  active
                    ? "bg-primary font-semibold text-primary-foreground shadow"
                    : "text-muted-foreground hover:bg-primary/5 hover:text-primary"
                }
              `}
              style={{ width: "60px" }}
            >
              <item.icon
                className={`mb-1 size-6 ${active ? "text-white" : ""}`}
              />
              <span className="text-xs">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
